if (!customElements.get('cart-checkout-message')) {
  class CartCheckoutMessage extends HTMLElement {
    static STORAGE_KEY = 'cart-checkout-region-selected';

    connectedCallback() {
      this.disabledMessage = document.getElementById('cart-checkout-disabled-message');
      this.enabledMessage = document.getElementById('cart-checkout-enabled-message');
      if (!this.disabledMessage && !this.enabledMessage) return;

      this.container = document.getElementById('cart-summary-and-blocks');
      this.hasSeenDisabled = false;
      this.observer = null;
      this.handleCartUpdate = this.handleCartUpdate.bind(this);

      this.init();
      document.addEventListener('on:line-item:change', this.handleCartUpdate);
    }

    disconnectedCallback() {
      this.disconnectObserver();
      document.removeEventListener('on:line-item:change', this.handleCartUpdate);
    }

    getCheckoutButton() {
      return this.container?.querySelector('button[name="checkout"]');
    }

    init() {
      this.disconnectObserver();
      this.updateMessages();

      const btn = this.getCheckoutButton();
      if (!btn) return;

      this.observer = new MutationObserver(() => this.updateMessages());
      this.observer.observe(btn, { attributes: true, attributeFilter: ['disabled'] });
    }

    handleCartUpdate() {
      requestAnimationFrame(() => {
        setTimeout(() => this.init(), 0);
      });
    }

    disconnectObserver() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }

    isResellerBypass() {
      if (window.sibrapeReseller?.isReseller === true) return true;

      try {
        const ref = sessionStorage.getItem('sibrape_ref');
        return Boolean(ref) && ref.toLowerCase().includes('revenda');
      } catch {
        return false;
      }
    }

    updateMessages() {
      const btn = this.getCheckoutButton();
      if (!btn) {
        this.setVisible(null);
        return;
      }

      const regionSelected = sessionStorage.getItem(CartCheckoutMessage.STORAGE_KEY) === 'true';

      if (btn.disabled) {
        this.hasSeenDisabled = true;
        sessionStorage.removeItem(CartCheckoutMessage.STORAGE_KEY);
        this.setVisible('disabled');
      } else if (this.isResellerBypass()) {
        // Referência de revenda libera o checkout sem seleção de região — não mostrar sucesso
        this.setVisible(null);
      } else if (this.hasSeenDisabled || regionSelected) {
        sessionStorage.setItem(CartCheckoutMessage.STORAGE_KEY, 'true');
        this.setVisible('enabled');
      } else {
        this.setVisible(null);
      }
    }

    setVisible(state) {
      if (this.disabledMessage) {
        this.disabledMessage.hidden = state !== 'disabled';
      }
      if (this.enabledMessage) {
        this.enabledMessage.hidden = state !== 'enabled';
      }
    }
  }

  customElements.define('cart-checkout-message', CartCheckoutMessage);
}
